import { createModel } from '@rematch/core';
import { PaginationType, ChatbotType, RootModel } from '@types';
import { ChatbotService } from '@services';
import baseEntity from './base.entity';
import { Dispatch } from '@redux/store';

interface ChatbotStateType {
  ids: { [id: number]: ChatbotType };
}

export const chatbotEntities = createModel<RootModel>()({
  state: { ids: {} } as ChatbotStateType,
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: Dispatch) => ({
    async load(payload): Promise<{ content: ChatbotType[] } & PaginationType> {
      const res = await ChatbotService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state): Promise<ChatbotType> {
      const item = state.chatbotEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await ChatbotService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await ChatbotService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await ChatbotService.create(payload));
      } else {
        ({ data: item } = await ChatbotService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
  }),
});
